// publicRoutes.js — rutas públicas sin autenticación (firma de presupuestos
// y contratos, abiertas por el cliente desde un enlace). Lista única para
// que App.js (qué se renderiza) y analytics.js (qué NUNCA debe iniciar
// PostHog) no puedan irse de sincronía — si se añade una ruta pública
// nueva, se añade aquí y ambos sitios quedan cubiertos a la vez.
//
// Por qué importa: PostHog estuvo grabando sesiones reales de clientes en
// /firmar/<id> porque initAnalytics() se llama sin mirar la ruta — un fallo
// de privacidad real, no solo de piloto (Rafa, 2026-11-05).
export const PUBLIC_PATH_PREFIXES = ['/firma-presupuesto/', '/firmar/'];

export function esRutaPublica(pathname = (typeof window !== 'undefined' ? window.location.pathname : '')) {
  return PUBLIC_PATH_PREFIXES.some(p => pathname.startsWith(p));
}
